import styled, { css } from 'styled-components';
import { RichTextPartial } from '@storefront/lib-global/partials/richText';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

const lineClamp = css`
  /* stylelint-disable value-no-vendor-prefix */
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 4;

  @media ${media.greaterThan('lg')} {
    -webkit-line-clamp: 3;
  }
  /* stylelint-enable value-no-vendor-prefix */
`;

export const ProductDescriptionContainer = styled.dl`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXS};
  margin: 0;
  text-align: left;

  @media ${media.greaterThan('lg')} {
    max-width: 523px;
  }
`;

export const ProductDescriptionHeaderText = styled.h3`
  ${TypographyStyles.Body.Medium.SemiBold}
  margin: 0;
`;

export const ProductDescriptionBody = styled.dd<{ $isExpanded: boolean; $lineHeight: string }>`
  ${TypographyStyles.Body.Small.Regular}
  margin: 0;
  overflow: hidden;

  &.truncate {
    ${({ $isExpanded }) => !$isExpanded && lineClamp}
    max-height: ${({ $lineHeight }) => `calc(${$lineHeight} * 4)`};
  }

  @media ${media.greaterThan('lg')} {
    &.truncate {
      max-height: ${({ $lineHeight }) => `calc(${$lineHeight} * 3)`};
    }
  }
`;

export const ProductDescriptionBodyText = styled.p`
  margin: 0;
`;

export const ProductDescriptionBodyFeatures = styled(RichTextPartial)`
  margin-top: 20px;

  & li::marker {
    font-size: 8px;
  }

  &:empty {
    display: none;
  }
`;

export const ProductDescriptionButtonContainer = styled.dd`
  margin: 0;
`;

export const ProductDescriptionButton = styled.button`
  ${TypographyStyles.CallToAction.Large.SemiBold}
  background: none;
  border: 0;
  color: ${colours.BLACK};
  padding: 0;
  text-decoration: underline;
`;
